/* eslint-disable no-underscore-dangle */
import * as React from "react";
import { Link } from "react-router-dom";

// Interfaces
import Topic from "../../types/Topic.interface";

// Misc.
import { useBaseState } from "../../context/Base.context";
import getCorrectPluralization from "../../lib/Pluralization.lib";

interface TopicCard {
  topic: Topic;
  className?: string;
}

const TopicCard: React.FunctionComponent<TopicCard> = (props: TopicCard) => {
  const { topic, className = "" } = props;
  const [qDone, setQDone] = React.useState(0);
  const [qOpen, setQOpen] = React.useState(topic.questions.length);
  const baseState = useBaseState();

  React.useEffect(() => {
    const { questions } = topic;

    const doneQuestions = questions.filter((question) => {
      return question._id in baseState;
    }).length;

    setQDone(doneQuestions);
    setQOpen(questions.length - doneQuestions);
  }, [baseState, topic, setQDone, setQOpen]);

  return (
    <Link to={`/category/${topic._id}`} className={`bg-white ${className}`}>
      <div className="relative pb-48 mb-2">
        <img
          src={topic.imageUrl}
          alt={topic.title}
          className="absolute h-full w-full object-cover"
        />
        <p className="absolute text-l md:text-24 font-semibold text-white font-serif mb-2 bottom-0 ml-2">
          {topic.title}
        </p>
      </div>
      <p className="text-dw-grey-12 md:text-s">{topic.description}</p>
      <p className="text-dw-grey-11 uppercase text-2xs mt-3">
        {`${getCorrectPluralization(qDone, "done")} | ${getCorrectPluralization(
          qOpen,
          "open"
        )}`}
      </p>
    </Link>
  );
};

export default TopicCard;
